/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { faqAdminControllerCreateV1 } from '../fn/faq-admin/faq-admin-controller-create-v-1';
import { FaqAdminControllerCreateV1$Params } from '../fn/faq-admin/faq-admin-controller-create-v-1';
import { faqAdminControllerDeleteV1 } from '../fn/faq-admin/faq-admin-controller-delete-v-1';
import { FaqAdminControllerDeleteV1$Params } from '../fn/faq-admin/faq-admin-controller-delete-v-1';
import { faqAdminControllerFindByIdV1 } from '../fn/faq-admin/faq-admin-controller-find-by-id-v-1';
import { FaqAdminControllerFindByIdV1$Params } from '../fn/faq-admin/faq-admin-controller-find-by-id-v-1';
import { faqAdminControllerReorderV1 } from '../fn/faq-admin/faq-admin-controller-reorder-v-1';
import { FaqAdminControllerReorderV1$Params } from '../fn/faq-admin/faq-admin-controller-reorder-v-1';
import { faqAdminControllerSearchV1 } from '../fn/faq-admin/faq-admin-controller-search-v-1';
import { FaqAdminControllerSearchV1$Params } from '../fn/faq-admin/faq-admin-controller-search-v-1';
import { faqAdminControllerToggleExposeV1 } from '../fn/faq-admin/faq-admin-controller-toggle-expose-v-1';
import { FaqAdminControllerToggleExposeV1$Params } from '../fn/faq-admin/faq-admin-controller-toggle-expose-v-1';
import { faqAdminControllerTogglePinV1 } from '../fn/faq-admin/faq-admin-controller-toggle-pin-v-1';
import { FaqAdminControllerTogglePinV1$Params } from '../fn/faq-admin/faq-admin-controller-toggle-pin-v-1';
import { faqAdminControllerUpdateV1 } from '../fn/faq-admin/faq-admin-controller-update-v-1';
import { FaqAdminControllerUpdateV1$Params } from '../fn/faq-admin/faq-admin-controller-update-v-1';
import { FaqDto } from '../models/faq-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class FaqAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `faqAdminControllerSearchV1()` */
  static readonly FaqAdminControllerSearchV1Path = '/api/v1/faqs/admin';

  /**
   * FAQ 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerSearchV1$Response(params: FaqAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = faqAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerSearchV1(params: FaqAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.faqAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `faqAdminControllerCreateV1()` */
  static readonly FaqAdminControllerCreateV1Path = '/api/v1/faqs/admin';

  /**
   * FAQ 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqAdminControllerCreateV1$Response(params: FaqAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = faqAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqAdminControllerCreateV1(params: FaqAdminControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.faqAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `faqAdminControllerFindByIdV1()` */
  static readonly FaqAdminControllerFindByIdV1Path = '/api/v1/faqs/admin/{id}';

  /**
   * FAQ 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerFindByIdV1$Response(params: FaqAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerFindByIdV1(params: FaqAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqAdminControllerDeleteV1()` */
  static readonly FaqAdminControllerDeleteV1Path = '/api/v1/faqs/admin/{id}';

  /**
   * FAQ 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerDeleteV1$Response(params: FaqAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = faqAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerDeleteV1(params: FaqAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.faqAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `faqAdminControllerUpdateV1()` */
  static readonly FaqAdminControllerUpdateV1Path = '/api/v1/faqs/admin/{id}';

  /**
   * FAQ 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqAdminControllerUpdateV1$Response(params: FaqAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = faqAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqAdminControllerUpdateV1(params: FaqAdminControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.faqAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `faqAdminControllerToggleExposeV1()` */
  static readonly FaqAdminControllerToggleExposeV1Path = '/api/v1/faqs/admin/{id}/toggle-expose';

  /**
   * FAQ 노출/비노출 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerToggleExposeV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerToggleExposeV1$Response(params: FaqAdminControllerToggleExposeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqAdminControllerToggleExposeV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 노출/비노출 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerToggleExposeV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerToggleExposeV1(params: FaqAdminControllerToggleExposeV1$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqAdminControllerToggleExposeV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqAdminControllerTogglePinV1()` */
  static readonly FaqAdminControllerTogglePinV1Path = '/api/v1/faqs/admin/{id}/toggle-pin';

  /**
   * FAQ 고정/비고정 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerTogglePinV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerTogglePinV1$Response(params: FaqAdminControllerTogglePinV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqAdminControllerTogglePinV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 고정/비고정 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerTogglePinV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqAdminControllerTogglePinV1(params: FaqAdminControllerTogglePinV1$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqAdminControllerTogglePinV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqAdminControllerReorderV1()` */
  static readonly FaqAdminControllerReorderV1Path = '/api/v1/faqs/admin/reorder';

  /**
   * FAQ 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqAdminControllerReorderV1$Response(params: FaqAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = faqAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqAdminControllerReorderV1(params: FaqAdminControllerReorderV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.faqAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
